// We only need to import the modules necessary for initial render
// When you add a first route be sure to remove the comment from the lines below.

import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import LazyComponent from 'Utility/LazyComponent';

const Home = lazy(() => import(/* webpackChunkName: "Home" */ './Home'));
const Users = lazy(() => import(/* webpackChunkName: "Users" */ './Users'));
const Transactions = lazy(() => import(/* webpackChunkName: "Transactions" */ './Transactions'));
const Groups = lazy(() => import(/* webpackChunkName: "Groups" */ './Groups'));
const ElectronicPurse = lazy(() => import(/* webpackChunkName: "ElectronicPurse" */ './ElectronicPurse'));
const Promotions = lazy(() => import(/* webpackChunkName: "Promotions" */ './Promotions'));
const Account = lazy(() => import(/* webpackChunkName: "Promotions" */ './Account'));
const Register = lazy(() => import(/* webpackChunkName: "Register" */ './Register'));
const Store = lazy(() => import(/* webpackChunkName: "Shops" */ './Store'));
const Merchant = lazy(() => import(/* webpackChunkName: "Merchant" */ './Merchant'));
const CustomerCare = lazy(() => import(/* webpackChunkName: "CustomerCare" */ './CustomerCare'));
const Userenrollment = lazy(() => import(/* webpackChunkName: "Userenrollment" */ './Userenrollment'));
const Payments = lazy(() => import(/* webpackChunkName: "Payments" */ './Payments'));
const StartEnrollment = lazy(() => import(/* webpackChunkName: "StartEnrollment" */ './StartEnrollment'));
const StartPayment = lazy(() => import(/* webpackChunkName: "StartPayment" */ './StartPayment'));
const ForgottenPassword = lazy(() => import(/* webpackChunkName: "ForgottenPassword" */ './ForgottenPassword'));
const ChangePasswordForced = lazy(() => import(/* webpackChunkName: "ChangePasswordForced" */ './ChangePasswordForced'));
const ChangePassword = lazy(() => import(/* webpackChunkName: "ChangePassword" */ './ChangePassword'));
  // @generator routes:import

export const Components = {
	// @generator routes:component export
ChangePassword,
ChangePasswordForced,
  StartPayment,
  StartEnrollment,
    ForgottenPassword,
	Userenrollment,
	Register,
	CustomerCare,
	Merchant,
	Store,
	Home,
	Users,
	Transactions,
	Groups,
	ElectronicPurse,
	Promotions,
	Account,
	Payments
};

export const createAuthRoutes = () => ({
	routes: [
		{
			routeName: 'Payment',
			component: (props) => (
				<Route path='/payment' key='Payment' element={<LazyComponent componentName='Payments' {...props} hasSaga hasReducer />} />
			),
		},
		{
			routeName: 'Home',
			component: (props) => (
				<Route path='/*' key='Home' element={<LazyComponent componentName='Home' {...props} hasSaga hasReducer />} />
			),
		},
		{
			routeName: 'Users',
			component: (props) => (
				<Route
					path='/users/*'
					key='Users'
					element={<LazyComponent componentName='Users' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'Transactions',
			component: (props) => (
				<Route
					path='/transactions/*'
					key='Transactions'
					element={<LazyComponent componentName='Transactions' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'ElectronicPurse',
			component: (props) => (
				<Route
					path='/electronic-purse/*'
					key='ElectronicPurse'
					element={<LazyComponent componentName='ElectronicPurse' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'Promotions',
			component: (props) => (
				<Route
					path='/promotions/*'
					key='Promotions'
					element={<LazyComponent componentName='Promotions' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'Groups',
			component: (props) => (
				<Route
					path='/groups/*'
					key='Groups'
					element={<LazyComponent componentName='Groups' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'Account',
			component: (props) => (
				<Route
					path='/account/*'
					key='Account'
					element={<LazyComponent componentName='Account' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'Merchant',
			component: (props) => (
				<Route
					path='/merchant/*'
					key='Merchant'
					element={<LazyComponent componentName='Merchant' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'Store',
			component: (props) => (
				<Route
					path='/store/*'
					key='Store'
					element={<LazyComponent componentName='Store' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'Register',
			component: (props) => (
				<Route
					path='/register/*'
					key='Register'
					element={<LazyComponent componentName='Register' {...props} hasSaga hasReducer />}
				/>
			),
		},
		{
			routeName: 'CustomerCare',
			component: (props) => (
				<Route
					path='/customer-care/*'
					key='CustomerCare'
					element={<LazyComponent componentName='CustomerCare' {...props} hasSaga hasReducer />}
				/>
			),
		},
    // @generator routes:define:auth

	],
});

// These routes don't need the user to be logged in.

export const createUnauthRoutes = () => ({
	routes: [
		{
			component: (props) => (
				<Route
					path='/user-enrollment'
					key='Userenrollment'
					element={<LazyComponent componentName='Userenrollment' {...props} />}
				/>
			),
		},
    {
			component: (props) => (
				<Route
					path='/startenrollment'
					key='StartEnrollment'
					element={<LazyComponent componentName="StartEnrollment"  {...props} />}
				/>
			)
  },
  {
  component: (props) => (
    <Route
      path='/startpayment'
      key='StartPayment'
      element={ <LazyComponent componentName="StartPayment"  {...props}  />}
    />
  )
}, {
  component: (props) => (
    <Route
      path='/forgottenpassword/*'
      key='ForgottenPassword'
      element={  <LazyComponent componentName="ForgottenPassword"  {...props} hasSaga hasReducer />}
    />
  )
}
, {
	component: (props) => (
	  <Route
		path='/signin/change-password/*'
		key='ChangePasswordForced'
		element={  <LazyComponent componentName="ChangePasswordForced"  {...props} hasSaga hasReducer />}
	  />
	)
  },{
  component: (props) => (
    <Route
      path='/change-password'
      key='ChangePassword'
      element={  <LazyComponent componentName="ChangePassword"  {...props} hasSaga hasReducer />}
    />
  )
}// @generator routes:define:unauth


	],
});

export default createAuthRoutes;
